import { consoleMarketplaceUrl, consoleUrl } from 'src/global';
import { MarketplaceCategorySlug, MlSpaceKind } from 'src/types/marketplace';

export const MARKETPLACE_PRODUCT_URL = `${consoleUrl}/u-api/bff-marketplace/v1/site/products/`;
export const MARKETPLACE_PRODUCTS_URL = `${consoleUrl}/u-api/bff-marketplace/v1/site/products-preview`;
export const MARKETPLACE_CATEGORIES_URL = `${consoleUrl}/u-api/bff-marketplace/v1/form/categories`;
export const MARKETPLACE_PRODUCT_TYPE_URL = `${consoleUrl}/u-api/bff-marketplace/v1/form/product-types`;

export const CONSOLE_OS_URL = `${consoleUrl}/spa/svp/virtual-machines/create`;
export const CONSOLE_SERVERLESS_CONTAINER_URL = `${consoleUrl}/spa/serverless-containers/containers/create/new`;
export const CONSOLE_ML_SPACE_URL = `${consoleUrl}/spa/mlspace`;
export const CONSOLE_MKP_URL = `${consoleMarketplaceUrl}/spa/main`;
export const CONSOLE_MKP_AI_HUB_URL = `${consoleMarketplaceUrl}/spa/ai-hub`;

export const SITE_MARKETPLACE_URL = '/marketplace';
export const getMarketplaceCategoryUrl = (categorySlug: string) =>
  categorySlug ? `/marketplace/${categorySlug}` : SITE_MARKETPLACE_URL;
export const getMarketplaceProductUrl = (slug: string) => {
  return `/marketplace/products/${slug}`;
};
export const getMarketplacePublishedProductUrl = (productId: string) => {
  return `${MARKETPLACE_PRODUCT_URL}${productId}`;
};
export const MARKETPLACE_AI_ML_URL = getMarketplaceCategoryUrl(
  MarketplaceCategorySlug.Aiml,
);

export const getMarketplaceConsoleProductUrl = (productSlug: string) =>
  `${CONSOLE_MKP_URL}/product/${productSlug}`;

export const getOsUrl = (externalId: string | undefined, freeTier?: boolean) =>
  `${CONSOLE_OS_URL}?image_id=${externalId}${
    freeTier ? '&free-tier=true' : ''
  }`;

export const getMlSpaceUrl = (
  externalId: string | undefined,
  kind: MlSpaceKind | undefined,
) =>
  kind === MlSpaceKind.Deploy
    ? `${CONSOLE_ML_SPACE_URL}/${externalId}?isOpenModal=true`
    : `${CONSOLE_ML_SPACE_URL}/artifact/${externalId}`;

export const getContainerAppsUrl = (externalId: string | undefined) =>
  `${CONSOLE_SERVERLESS_CONTAINER_URL}?quickStartArtifactId=${externalId}`;

export const getAiHubUrl = () => {
  return `${CONSOLE_MKP_AI_HUB_URL}`;
};

export const formatDisplayName = (displayName: string) => {
  const baseSplit = displayName.split('-');
  const tooLongToTruncate = baseSplit.length > 0 && baseSplit[0].length > 25;

  return tooLongToTruncate ? displayName.split('/').join(' / ') : displayName;
};
